import abi from "./NestcoinToken.json";

export const contractAddress = "0x43f71fbd58e9600924f49a53c6fde787977c2b9d";
export const contractABI = abi.abi;
